import { combineReducers } from 'redux';
import structureModelingAnalytics from './StructureModelAnalytics/reducers/StructureModelingAnalyticsReducer';
import structureBulkCopy from './StructureBulkCopy/StructureBulkCopyReducer';
import structureBulkCreate from './StructureBulkCreate/StructureBulkCreateReducer';

import { STRUCTURE_MODELING_TARGET_ELEMENETS_SUCCESS } from './StructureModelingActions';

export const initialState = {
  targetElements: []
};

function sharedData(state = initialState, action) {
  switch (action.type) {
    case STRUCTURE_MODELING_TARGET_ELEMENETS_SUCCESS:
      return {
        ...state,
        targetElements: action.targetElements.map(element => {
          return {
            label: element.text,
            value: element
          };
        })
      };
    default: {
      return state;
    }
  }
}

export default combineReducers({
  structureModelingAnalytics,
  structureBulkCreate,
  structureBulkCopy,
  sharedData
});
